/**
 * Mutation hooks for Athlete operations
 * Replaces delete() and save() methods on Athlete model
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useBackend } from './useBackend';
import { Athlete } from '../Model/Athlete/Athlete';

export function useSaveAthlete() {
  const backend = useBackend();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (athlete: Athlete) => backend.post('/athlete', athlete),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['athlete'] });
    },
  });
}

export function useDeleteAthlete() {
  const backend = useBackend();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => backend.delete('/athlete'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['athlete'] });
    },
  });
}
